import { getEnumValues } from '@principle-theorem/shared';

/**
 * The mutually exclusive contexts a booking can be made in. Deposit settings
 * declare which of these a deposit applies to, so a practice can (for example)
 * take deposits from online bookings and new patients but not from established
 * patients ringing up.
 *
 * Every booking resolves to exactly one context: an online booking is always
 * {@link DepositBookingContext.Online} regardless of whether the patient is new,
 * and a phone/walk-in booking taken by staff resolves to one of the two staff
 * contexts based on the patient's appointment history.
 */
export enum DepositBookingContext {
  Online = 'online',
  StaffNewPatient = 'staffNewPatient',
  StaffExistingPatient = 'staffExistingPatient',
}

/**
 * All booking contexts, in the order they should be presented in settings UI.
 * Also the default applicability when a brand has not configured `appliesTo`.
 */
export const DEPOSIT_BOOKING_CONTEXTS: DepositBookingContext[] = getEnumValues(
  DepositBookingContext
);

export const DEPOSIT_BOOKING_CONTEXT_LABELS: Record<
  DepositBookingContext,
  string
> = {
  [DepositBookingContext.Online]: 'Online bookings',
  [DepositBookingContext.StaffNewPatient]: 'Staff bookings (new patients)',
  [DepositBookingContext.StaffExistingPatient]:
    'Staff bookings (existing patients)',
};
